import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, X, ChevronRight, ChevronDown } from 'lucide-react';

/**
 * Encart « Parrainage » en tête d'une thématique éditoriale (14/10/2026).
 *
 * À ne pas confondre avec le PARTAGE des thématiques perso (codes d'accès, icône Share2,
 * teinte violette) : ici l'icône cadeau, la teinte or et le mot « Parrainer », jamais
 * « Partager ». Le lien ouvre Compte > Parrainage avec cette thématique (et le parcours
 * choisi) présélectionnée sur le visuel. Masquable, mémorisé sur l'appareil.
 * Mobile : une seule ligne repliée (« 7 jours offerts pour vous deux »), le détail au toucher.
 */
// Thématiques nommables sur le visuel : même liste que $SHARE dans api/user/referral.php.
const PARRAINABLE = ['fonction-publique-etat', 'fonction-publique-territoriale', 'police-gendarmerie', 'crpe', 'sante-social', 'atsem'];
const HIDE_KEY = 'mq_parrainage_encart_off';

// partner : thématique communautaire (ISTQB…), parrainable elle aussi.
export default function ParrainageEncart({ scopeSlug, parcours = '', partner = false }) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [hidden, setHidden] = useState(() => { try { return localStorage.getItem(HIDE_KEY) === '1'; } catch { return false; } });
    if (hidden || !(partner || PARRAINABLE.includes(scopeSlug))) return null;

    const target = parcours ? `parcours:${parcours}` : `scope:${scopeSlug}`;
    const hide = () => {
        setHidden(true);
        try { localStorage.setItem(HIDE_KEY, '1'); } catch { /* pas de stockage */ }
    };

    return (
        <aside className={`parrainage-encart${open ? ' is-open' : ''}`} aria-label="Parrainage">
            <button type="button" className="parrainage-encart__mini" onClick={() => setOpen(true)} aria-expanded={open}>
                <Gift size={16} /> <span><b>Parrainage</b> · 7 jours offerts pour vous deux</span> <ChevronDown size={16} />
            </button>
            <span className="parrainage-encart__icon" aria-hidden="true"><Gift size={20} /></span>
            <div className="parrainage-encart__text">
                <span className="parrainage-encart__kicker">Nouveau · Parrainage</span>
                <strong>Un ami prépare aussi {partner ? 'cette thématique' : 'ce concours'} ? 7 jours offerts pour vous deux.</strong>
                <span>Dès son premier abonnement avec votre code, vous gagnez chacun une semaine.</span>
            </div>
            <button type="button" className="parrainage-encart__cta"
                onClick={() => navigate(`/compte/account/parrainage?scope=${encodeURIComponent(scopeSlug)}&t=${encodeURIComponent(target)}`)}>
                Parrainer un ami <ChevronRight size={16} />
            </button>
            <button type="button" className="parrainage-encart__close" onClick={hide} aria-label="Masquer l’encart parrainage" title="Masquer">
                <X size={16} />
            </button>
        </aside>
    );
}
